import { render, staticRenderFns } from "./FormFileInput.vue?vue&type=template&id=16bb1dca&"
import script from "./FormFileInput.vue?vue&type=script&lang=js&"
export * from "./FormFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports